import { BoostedWheelTheme } from "../modules/boostedJackpotModule/boostedJackpot/partnerWheelTheme";

import DefaultButtonBG from '../../assets/images/wheel/default.png';
import IchancyButtonBG from '../../assets/images/wheel/ichancy.png';
import Bet55ButtonBG from '../../assets/images/wheel/bet55.png';

const ThemeConfigs = {
    Default: {
        sectorColors: ['#0b1b56', '#0c1121'],
        sectorTextColors: ['#ffcd6a', '#ffffff'],
        sectorAlpha: 0.45,
        buttonTextColor: '#FFCD6A',
        buttonDropShadow: true,
        buttonShadowColor: '#261d0a',
        buttonBackgroundImage: DefaultButtonBG
    },
    [BoostedWheelTheme.IChancy]: {
        sectorColors: ['#0c1a26', '#0a0d18'],
        sectorTextColors: ['#ffcd6a', '#ffffff'],
        sectorAlpha: 0.45,
        buttonTextColor: '#ffffff',
        buttonDropShadow: true,
        buttonShadowColor: '#000000',
        buttonBackgroundImage: IchancyButtonBG
    },
    [BoostedWheelTheme.Bet55]: {
        sectorColors: ['#2d250e', '#0b0b0c'],
        sectorTextColors: ['#ffcd6a', '#ffffff'],
        sectorAlpha: 0.45,
        buttonDropShadow: false,
        buttonTextColor: '#000000',
        buttonShadowColor: 'transparent',
        buttonBackgroundImage: Bet55ButtonBG
    },
};

const createPGWheelThemeConfigsProxy = (config: typeof ThemeConfigs) => {
  return new Proxy(config, {
    get: (target, prop: any) => {
      return target[prop] || ThemeConfigs.Default;
    }
  });
};

export const PgWheelThemeConfigs = createPGWheelThemeConfigsProxy(ThemeConfigs);
